import React from 'react';
import Link from 'next/link';
import ButtonLink from 'app/components/ButtonLink';
import PurifiedText from 'ui/src/components/PurifiedText';

export type TopicsNavigationProps = {
  title: string;
  topics: { label: string; count: number; href: string }[];
  allArticles?: { label: string; href: string };
};

export default function TopicsNavigation({ title, topics, allArticles }: TopicsNavigationProps) {
  return (
    <nav className="mdL:order-none order-last" aria-label={title}>
      <PurifiedText as="h2" className="site-overline-s text-site-neutrals-600 mb-4">
        {title}
      </PurifiedText>
      <ul className="flex flex-col gap-1">
        {topics.map((topic) => (
          <li key={topic.href}>
            <Link
              href={topic.href}
              className="border-site-neutrals-50 flex items-start justify-between gap-2 border-t py-2"
            >
              <span className="site-paragraph-s text-site-neutrals-600">{topic.label}</span>
              <span className="site-paragraph-xs text-site-neutrals-300">{topic.count}</span>
            </Link>
          </li>
        ))}
      </ul>
      {allArticles && (
        <ButtonLink
          href={allArticles.href}
          variant="TextOnly"
          variantColor="Black"
          size="Small"
          iconName="ArrowForward"
          iconSize="IconS"
          classes="mt-3"
        >
          {allArticles.label}
        </ButtonLink>
      )}
    </nav>
  );
}
